import { Observable } from 'rxjs/Observable';
import getUserTemplates from '../actions/templates/getUserTemplatesAction';

export function handleDeleteTemplateFulfilled(action$, store) {
    return action$.filter(
        action => action.type === 'DELETE_TEMPLATE_FULFILLED')
        .mergeMap(() => Observable.merge(
            Observable.of(getUserTemplates(store.getState().user.data.objectId))))
}



// WEBPACK FOOTER //
// ./src/epics/deleteTemplateEpic.js